export function formatDate(timestamp?: { _seconds: number; _nanoseconds: number }): string {
  if (!timestamp) return "—";
  const date = new Date(timestamp._seconds * 1000);
  return date.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
